import { render, staticRenderFns } from "./OrderSheetViewTabInformation.vue?vue&type=template&id=6393ed8e&"
import script from "./OrderSheetViewTabInformation.vue?vue&type=script&lang=js&"
export * from "./OrderSheetViewTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrderSheetViewTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports